import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

function SearchButton({ value, onChange }) {
	return (
		<div>
			<div className='relative bg-white shadow-md shadow-gray-200 rounded-lg w-full'>
				<span className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
					<SearchOutlinedIcon className='text-gray-400' />
				</span>
				<input
					value={value}
					onChange={(e) => onChange(e.target.value)}
					className='pl-10 bg-white pr-4 py-3 rounded-lg border-gray-200 outline-0 block w-full text-sm border focus:border-primary-color transition-colors'
					placeholder='Search building name or ID'
				/>
			</div>
		</div>
	);
}

export default SearchButton;
